import { get, post, put, del, postForm } from 'utils/methods';

export function getResellersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}resellers`, data, headers);
}

export function addNewResellerApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/reseller`, data, headers);
}

export function editResellerApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/reseller`, data, headers);
}

export function getSegmentsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}segment`, data, headers);
}

export function getProductGroupsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}products-groups`, data, headers);
}

export function addSegmentProductGroupApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/segment/reseller-product`, data, headers);
}

export function deleteAllSegmentProductGroupApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/segment/reseller-product`, data, headers);
}

export function orderResellerSegmentsApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/segment/order`, data, headers);
}

export function attachResellerSegmentApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/segment/reseller`, data, headers);
}

export function addTemplateToResellerApi(data, headers) {
    return postForm(`${process.env.REACT_APP_REST}commands/reseller/invoice-template`, data, headers);
}

export function deleteTemplateToResellerApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/reseller/invoice-template`, data, headers);
}
